import React from 'react';

export const CustomIcon: React.FC<{ icon: string }> = (props) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: props.icon }} />
  );
};
export default CustomIcon;
